import React from 'react';
import { TrendingUp, TrendingDown, Clock, Calendar, Power, CheckCircle, Target, Timer } from 'lucide-react';
import { useTransferSummary } from '../../hooks';
import { QuickStatsCard } from '@features/cx/shared/components/QuickStatsCard';
import { useRemoteUtilityId } from '@shared/selectors/globalSelectors';

export const Summary: React.FC = () => {
  const remoteUtilityId = useRemoteUtilityId();
  const { data: summaryData } = useTransferSummary({
    remoteUtilityId: Number(remoteUtilityId),
    requestType: 'Transfer',
  });

  const summaryCards = [
    {
      title: 'Pending Transfers',
      tooltip: 'Transfer requests that are logged but not yet completed.',
      value: summaryData?.pendingTransfers,
      change: `${summaryData?.percentChange?.pending}% vs. last month`,
      trend: 'up' as const,
      icon: <Clock className="h-8 w-8 text-orange-500" />,
      color: 'text-orange-600'
    },
    {
      title: 'Completed',
      tooltip: 'Transfer requests successfully processed and closed.',
      value: summaryData?.completedThisMonth,
      change: `${summaryData?.percentChange?.completed}% vs. last month`,
      trend: 'up' as const,
      icon: <CheckCircle className="h-8 w-8 text-green-500" />,
      color: 'text-green-600'
    },
    {
      title: 'Avg Processing Time',
      tooltip: 'Average time taken to complete transfer requests.',
      value: summaryData?.averageProcessingTimeDays,
      change: `${summaryData?.percentChange?.averageProcessingTime}% vs. last month`,
      trend: 'down' as const,
      icon: <Timer className="h-8 w-8 text-blue-500" />,
      color: 'text-blue-600',
      suffix: 'days'
    },
    {
      title: 'Success Rate',
      tooltip: 'Percentage of transfer requests completed successfully.',
      value: summaryData?.successRate,
      change: `${summaryData?.percentChange?.successRate}% vs. last month`,
      trend: 'up' as const,
      icon: <Target className="h-8 w-8 text-purple-500" />,
      color: 'text-purple-600',
      suffix: '%'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {summaryCards.map((card, index) => (
        <QuickStatsCard 
          key={index}
          title={card.title}
          count={card.value}
          trendDirection={card.trend}
          trendSummary={card.change}
          icon={card.icon}
          tooltip={card.tooltip}
        />
      ))}
    </div>
  );
};